module.exports = __webpack_public_path__ + "img/多元智能测试.8e48622f.png";